import React, { Component } from "react";
import { injectIntl } from "react-intl";
import moment from "moment";

import "./DateTimeFormat.scss";

class DatetimeFormat extends Component {
  getLongFormattedDate(dateTime) {
    const { formatMessage } = this.props.intl;

    const diffDays = moment()
      .endOf("day")
      .diff(moment(dateTime).endOf("day"), "days");
    if (diffDays === 0) {
      return moment(dateTime).format(
        `[${formatMessage({ id: "date.today" })}, ] LL`
      );
    } else if (diffDays === 1) {
      return moment(dateTime).format(
        `[${formatMessage({ id: "date.yesterday" })}, ] LL`
      );
    } else if (diffDays < 31) {
      return moment(dateTime).format(`dddd, LL`);
    } else {
      return moment(dateTime).format(`LL`);
    }
  }

  getShortFormattedDate(dateTime) {
    const { formatMessage } = this.props.intl;

    const diffSeconds = moment().diff(moment(dateTime), "seconds");
    const diffMinutes = moment().diff(moment(dateTime), "minutes");
    const diffHours = moment().diff(moment(dateTime), "hours");
    const diffDays = moment().diff(moment(dateTime), "days");
    const diffMonths = moment().diff(moment(dateTime), "months");
    const diffYears = moment().diff(moment(dateTime), "years");

    if (diffSeconds < 60) {
      return formatMessage({ id: "date.now" });
    } else if (diffMinutes < 60) {
      return `${diffMinutes} ${formatMessage({ id: "date.shortMinute" })}`;
    } else if (diffHours < 24) {
      return `${diffHours} ${formatMessage({ id: "date.shortHour" })}`;
    } else if (diffDays === 1) {
      return `1 ${formatMessage({ id: "date.shortDay" })}`;
    } else if (diffDays < 31) {
      return `${diffDays} ${formatMessage({ id: "date.shortDays" })}`;
    } else if (diffMonths === 1) {
      return `1 ${formatMessage({ id: "date.shortMonth" })}`;
    } else if (diffMonths < 12) {
      return `${diffMonths} ${formatMessage({ id: "date.shortMonths" })}`;
    } else if (diffYears === 1) {
      return `1 ${formatMessage({ id: "date.shortYear" })}`;
    } else if (diffYears > 1) {
      return `${diffYears} ${formatMessage({ id: "date.shortYears" })}`;
    } else {
      return moment(dateTime).format(`LL`);
    }
  }

  getTimeFormatted(dateTime) {
    return moment(dateTime).format("HH:mm");
  }

  getFormattedDate(dateTime) {
    // dateTime = this.formatDate(dateTime)

    if (this.props.long) {
      return this.getLongFormattedDate(dateTime);
    } else if (this.props.short) {
      return this.getShortFormattedDate(dateTime);
    } else if (this.props.time) {
      return this.getTimeFormatted(dateTime);
    }
  }

  /**
   * @deprecated
   */
  formatDate(dateToFormat) {
    let formattedDate = dateToFormat;
    if (isNaN(formattedDate)) {
      let date = formattedDate.split(" ")[0];
      let time = formattedDate.split(" ")[1];
      date = date.split("-");
      time = time.split(":");
      formattedDate =
        date[1] +
        "/" +
        date[2] +
        "/" +
        date[0] +
        "/" +
        time[0] +
        ":" +
        time[1] +
        ":" +
        time[2];
    }
    return formattedDate;
  }

  render() {
    const { dateTime } = this.props;

    return (
      <span className={`datetime-format ${this.props.className}`}>
        {this.getFormattedDate(dateTime)}
      </span>
    );
  }
}

export default injectIntl(DatetimeFormat);
